var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLog(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.34633 9.21151C9.73928 9.3425 10.164 9.13013 10.295 8.73717C10.426 8.34421 10.2136 7.91947 9.82067 7.78849L9.34633 9.21151ZM7.3335 7.75H6.5835C6.5835 8.07282 6.79007 8.35943 7.09633 8.46151L7.3335 7.75ZM8.0835 4.61391C8.0835 4.1997 7.74771 3.86391 7.3335 3.86391C6.91928 3.86391 6.5835 4.1997 6.5835 4.61391H8.0835ZM9.82067 7.78849L7.57067 7.03849L7.09633 8.46151L9.34633 9.21151L9.82067 7.78849ZM8.0835 7.75V4.61391H6.5835V7.75H8.0835ZM12.5835 7C12.5835 9.8995 10.233 12.25 7.3335 12.25V13.75C11.0614 13.75 14.0835 10.7279 14.0835 7H12.5835ZM7.3335 12.25C4.434 12.25 2.0835 9.8995 2.0835 7H0.583496C0.583496 10.7279 3.60557 13.75 7.3335 13.75V12.25ZM2.0835 7C2.0835 4.1005 4.434 1.75 7.3335 1.75V0.25C3.60557 0.25 0.583496 3.27208 0.583496 7H2.0835ZM7.3335 1.75C10.233 1.75 12.5835 4.1005 12.5835 7H14.0835C14.0835 3.27208 11.0614 0.25 7.3335 0.25V1.75Z",
    fill: "#393736",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLog);
export default __webpack_public_path__ + "static/media/log.40de5a6c307e9ead0ea34e0b6f8a2cf6.svg";
export { ForwardRef as ReactComponent };